import { useTreeStore } from '@/stores/treeStore';

/**
 * Custom hook for accessing tree store state and actions.
 *
 */
export function useTree() {
  const contextMenu = useTreeStore((state) => state.contextMenu);

  // Actions (functions are fine to expose - no performance impact)
  const setNode = useTreeStore((state) => state.setNode);
  const setNodes = useTreeStore((state) => state.setNodes);
  const setExpandedNodes = useTreeStore((state) => state.setExpandedNodes);
  const setContextMenu = useTreeStore((state) => state.setContextMenu);
  const setDataModified = useTreeStore((state) => state.setDataModified);
  const createNode = useTreeStore((state) => state.createNode);
  const updateData = useTreeStore((state) => state.updateData);
  const updateDataPartial = useTreeStore((state) => state.updateDataPartial);
  const mergeEntityFromServer = useTreeStore((state) => state.mergeEntityFromServer);
  const deleteNode = useTreeStore((state) => state.deleteNode);
  const loadFiles = useTreeStore((state) => state.loadFiles);
  const loadNotes = useTreeStore((state) => state.loadNotes);
  const initializeTree = useTreeStore((state) => state.initializeTree);
  const clearContextMenu = useTreeStore((state) => state.clearContextMenu);
  const loadChildren = useTreeStore((state) => state.loadChildren);
  const clearChildrenLoaded = useTreeStore((state) => state.clearChildrenLoaded);
  const invalidateChildrenCache = useTreeStore((state) => state.invalidateChildrenCache);
  const reloadNode = useTreeStore((state) => state.reloadNode);
  const reloadNodeData = useTreeStore((state) => state.reloadNodeData);
  const addFiles = useTreeStore((state) => state.addFiles);
  const replaceFile = useTreeStore((state) => state.replaceFile);
  const removeFile = useTreeStore((state) => state.removeFile);
  const getNodeData = useTreeStore((state) => state.getNodeData);
  const getNodeDisplayName = useTreeStore((state) => state.getNodeDisplayName);
  const expandNode = useTreeStore((state) => state.expandNode);

  // Data access methods
  const getData = useTreeStore((state) => state.getData);
  const getTypedData = useTreeStore((state) => state.getTypedData);
  const getNotes = useTreeStore((state) => state.getNotes);
  const getFiles = useTreeStore((state) => state.getFiles);
  const getSampleRequests = useTreeStore((state) => state.getSampleRequests);
  const setSampleRequests = useTreeStore((state) => state.setSampleRequests);

  // Type-safe data access helpers (functions are fine)
  const getSampleData = useTreeStore((state) => state.getSampleData);
  const getProjectData = useTreeStore((state) => state.getProjectData);
  const getSampleActivityData = useTreeStore((state) => state.getSampleActivityData);
  const getProjectActivityData = useTreeStore((state) => state.getProjectActivityData);
  const getTheoryActivityData = useTreeStore((state) => state.getTheoryActivityData);
  const getDataPackageData = useTreeStore((state) => state.getDataPackageData);
  const getCommunicationData = useTreeStore((state) => state.getCommunicationData);
  const getShippingData = useTreeStore((state) => state.getShippingData);
  const getPublicationData = useTreeStore((state) => state.getPublicationData);

  // Function-based checks (fine to expose)
  const areChildrenLoaded = useTreeStore((state) => state.areChildrenLoaded);
  const isDataModified = useTreeStore((state) => state.isDataModified);
  const hasModifiedDataInSubtree = useTreeStore((state) => state.hasModifiedDataInSubtree);

  return {
    // Context menu (fine to expose)
    contextMenu,
    setContextMenu,
    clearContextMenu,

    // Tree management actions (functions are fine - no performance impact)
    setNode,
    setNodes,
    setExpandedNodes,
    setDataModified,
    createNode,
    updateData,
    updateDataPartial,
    mergeEntityFromServer,
    deleteNode,
    loadFiles,
    loadNotes,
    initializeTree,
    reloadNode,
    reloadNodeData,
    addFiles,
    replaceFile,
    removeFile,
    getNodeData,
    getNodeDisplayName,
    loadChildren,
    clearChildrenLoaded,
    invalidateChildrenCache,
    expandNode,

    // Data access methods (functions are fine - no performance impact)
    getData,
    getTypedData,
    getNotes,
    getFiles,
    getSampleRequests,
    setSampleRequests,
    areChildrenLoaded,
    isDataModified,
    hasModifiedDataInSubtree,

    // Type-safe data access helpers (functions are fine - no performance impact)
    getSampleData,
    getProjectData,
    getSampleActivityData,
    getProjectActivityData,
    getTheoryActivityData,
    getDataPackageData,
    getCommunicationData,
    getShippingData,
    getPublicationData,
  };
}
